import { ref, onUnmounted } from 'vue'

export function useDebounce(delay: number = 300) {
  const timeoutId = ref<number | null>(null)

  const debounce = <T extends (...args: any[]) => any>(fn: T) => {
    return (...args: Parameters<T>) => {
      if (timeoutId.value) {
        clearTimeout(timeoutId.value)
      }

      timeoutId.value = setTimeout(() => {
        fn(...args)
        timeoutId.value = null
      }, delay)
    }
  }

  onUnmounted(() => {
    if (timeoutId.value) {
      clearTimeout(timeoutId.value)
    }
  })

  return {
    debounce
  }
} 